import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useContextSystem } from '@wp-g2/context';
import { css, cx, ui } from '@wp-g2/styles';
import { useMemo } from 'react';
import * as styles from './Surface.styles';
/**
 * @param {import('@wp-g2/create-styles').ViewOwnProps<import('./types').Props, 'div'>} props
 */

export function useSurface(props) {
  var _useContextSystem = useContextSystem(props, 'Surface'),
      _useContextSystem$bac = _useContextSystem.backgroundSize,
      backgroundSize = _useContextSystem$bac === void 0 ? 16 : _useContextSystem$bac,
      border = _useContextSystem.border,
      borderBottom = _useContextSystem.borderBottom,
      borderLeft = _useContextSystem.borderLeft,
      borderRight = _useContextSystem.borderRight,
      borderTop = _useContextSystem.borderTop,
      className = _useContextSystem.className,
      _useContextSystem$var = _useContextSystem.variant,
      variant = _useContextSystem$var === void 0 ? 'primary' : _useContextSystem$var,
      otherProps = _objectWithoutProperties(_useContextSystem, ["backgroundSize", "border", "borderBottom", "borderLeft", "borderRight", "borderTop", "className", "variant"]);

  var classes = useMemo(function () {
    var _css;

    var sx = {};
    sx.borders = styles.getBorders({
      border: border,
      borderBottom: borderBottom,
      borderLeft: borderLeft,
      borderRight: borderRight,
      borderTop: borderTop
    });
    return cx(styles.Surface, sx.borders, styles[variant], css((_css = {}, _css[ui.createToken('surfaceBackgroundSize')] = ui.value.px(backgroundSize), _css[ui.createToken('surfaceBackgroundSizeDotted')] = ui.value.px(backgroundSize - 1), _css)), className);
  }, [backgroundSize, border, borderBottom, borderLeft, borderRight, borderTop, className, variant]);
  return _objectSpread(_objectSpread({}, otherProps), {}, {
    className: classes
  });
}